import { render, staticRenderFns } from "./feature-item-search.vue?vue&type=template&id=526b6e22&scoped=true"
import script from "./feature-item-search.vue?vue&type=script&lang=js"
export * from "./feature-item-search.vue?vue&type=script&lang=js"
import style0 from "./feature-item-search.vue?vue&type=style&index=0&id=526b6e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526b6e22",
  null
  
)

export default component.exports